// Formatting + domain helpers for the Odisha SSSSO dashboard (schema v3)

const nf = new Intl.NumberFormat("en-IN");

export const fmt = (n) => {
    if (n === null || n === undefined || Number.isNaN(n)) return "—";
    return nf.format(n);
};

export const fmtDecimal = (n, d = 1) => {
    if (n === null || n === undefined || Number.isNaN(n)) return "—";
    return Number(n).toFixed(d);
};

export const fmtPct = (n, d = 1) => {
    if (n === null || n === undefined || Number.isNaN(n)) return "—";
    return `${Number(n).toFixed(d)}%`;
};

export const fmtCompact = (n) => {
    if (n === null || n === undefined || Number.isNaN(n)) return "—";
    if (Math.abs(n) >= 100000) return `${(n / 100000).toFixed(1)}L`;
    if (Math.abs(n) >= 1000) return `${(n / 1000).toFixed(1)}k`;
    return nf.format(n);
};

export const humanize = (s) =>
    (s || "")
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());

// Activity wings
export const WINGS = [
    { code: "spiritual", name: "Spiritual", chart: "1" },
    { code: "education", name: "Education", chart: "2" },
    { code: "service", name: "Service", chart: "3" },
    { code: "meetings_conferences", name: "Meetings & Conferences", chart: "4" },
    { code: "training", name: "Training", chart: "5" },
    { code: "other", name: "Other", chart: "6" },
];

// Activity groups (for trend tabs & drilldown breakdowns)
export const GROUPS = [
    { code: "total", name: "Total", chart: "1" },
    { code: "core", name: "Core", chart: "3" },
    { code: "spiritual", name: "Spiritual", chart: "1" },
    { code: "education", name: "Education", chart: "2" },
    { code: "service", name: "Service", chart: "3" },
    { code: "ancillary", name: "Ancillary", chart: "4" },
];

// Breakdown rows for a single entity's wing_details (drilldown)
export const CORE_WINGS = ["spiritual", "education", "service"];
export const ANCILLARY_WINGS = ["meetings_conferences", "training", "other"];

export const chartColor = (n) => `hsl(var(--chart-${n}))`;

export const wingColor = (code) => {
    const w = WINGS.find((x) => x.code === code);
    return chartColor(w ? w.chart : "6");
};

export const groupColor = (code) => {
    const g = GROUPS.find((x) => x.code === code);
    return chartColor(g ? g.chart : "1");
};

export const wingName = (code) => {
    const w = WINGS.find((x) => x.code === code);
    return w ? w.name : humanize(code);
};

// Gender palette
export const GENDER_COLORS = {
    gents: chartColor(2),
    ladies: chartColor(4),
    youth: chartColor(1),
    senior: chartColor(6),
    gents_senior: chartColor(2),
    gents_youth: chartColor(5),
    ladies_senior: chartColor(4),
    ladies_youth: chartColor(1),
};

// Safely read youth participation % from a node with gender_engagement
export const youthPct = (node) => {
    if (!node) return 0;
    const ge = node.gender_engagement;
    if (ge && ge.youth_share_of_senior_plus_youth_pct != null) return ge.youth_share_of_senior_plus_youth_pct;
    if (node.youth_participation_pct != null) return node.youth_participation_pct;
    return 0;
};

export const totalYouth = (node) => node?.gender_engagement?.total_youth ?? 0;

// status tone mapping
const STATUS_TONE = {
    excellent: "success",
    healthy: "success",
    healthy_representation: "success",
    well_balanced: "success",
    very_diversified: "success",
    balanced: "success",
    healthy_balance: "success",
    moderately_balanced: "warning",
    slightly_under_represented: "warning",
    concentrated: "warning",
    very_repetitive: "warning",
    highly_repetitive: "warning",
    uneven: "warning",
    many_one_off_activities: "warning",
    depth_oriented: "accent",
    needs_attention: "destructive",
    highly_concentrated: "destructive",
    not_available: "muted",
};

export const statusTone = (status) => STATUS_TONE[status] || "muted";
export const statusLabel = (status) => humanize(status);

// severity -> tone for areas needing attention
export const severityTone = (sev) => {
    if (sev === "high" || sev === "critical") return "destructive";
    if (sev === "medium") return "warning";
    if (sev === "low") return "accent";
    return "muted";
};

export const vacancyTone = (pct) => {
    if (pct >= 30) return "destructive";
    if (pct >= 20) return "warning";
    if (pct >= 10) return "accent";
    return "success";
};

export const toneStroke = {
    success: "hsl(var(--success))",
    warning: "hsl(var(--warning))",
    destructive: "hsl(var(--destructive))",
    accent: "hsl(var(--accent))",
    muted: "hsl(var(--muted-foreground))",
    primary: "hsl(var(--primary))",
};
